import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		root: {
			'& .slick-list': {
				padding: `0 ${theme.spacing(3)} 0 0 !important`,
			},
		},
	}),
	{ name: 'Slider' },
)

export default useStyles
